import React, { useState, useEffect } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  AiOutlineDashboard,
  AiOutlineUser,
  AiOutlineFlag,
  AiOutlineDollar,
  AiFillAccountBook
} from "react-icons/ai";
import { AiOutlineNotification } from "react-icons/ai";
import { AiOutlineMenu } from "react-icons/ai";
import { Link } from 'react-router-dom';
import { logout } from './../features/auth/authSlice';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Outlet } from "react-router-dom";
import { IoIosSettings } from "react-icons/io";

import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
const { Header, Sider, Content } = Layout;

const MainLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle window resize to detect mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      // Auto-collapse sidebar on mobile
      if (window.innerWidth <= 768) {
        setCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Check on initial load
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const savedKeys = localStorage.getItem('selectedMenuKeys');
    const savedOpenKeys = localStorage.getItem('openMenuKeys');
    if (savedKeys) {
      setSelectedKeys(JSON.parse(savedKeys));
    }
    if (savedOpenKeys) {
      setOpenKeys(JSON.parse(savedOpenKeys));
    }
  }, []);
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const isLogin = useSelector((state) => state.auth.isLogin);
  const user = useSelector((state) => state.auth.user);

  const handleSignout = (event) => {
    event.preventDefault();
    dispatch(logout());
  };

  useEffect(() => {
    if (!isLogin) {
      navigate("/");
    }
  }, [isLogin, navigate]);


  return (
    <Layout>
      <Sider trigger={null}
        collapsible
        collapsed={collapsed}
        style={{ 
          background: "#179296",
          position: isMobile ? 'fixed' : 'relative',
          height: '100vh',
          zIndex: 999,
          display: isMobile && collapsed ? 'none' : 'block',
          transition: 'all 0.2s'
        }}
      >
        <div className="logo">
          <h2 className="text-white fs-5 text-center py-3 mb-0">
            <span className="sm-logo" style={{ color: "black" }}>BALI</span>
            <span className="lg-logo">
              <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Login" style={{width: 100}} />
            </span>
          </h2>
        </div>
        <Menu
          style={{ background: "#179296", color: "white" }}
          theme="light"
          mode="inline"
          selectedKeys={selectedKeys}
          openKeys={openKeys}
          onOpenChange={(keys) => {
            // Only keep the most recently opened submenu
            const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
            if (latestOpenKey) {
              setOpenKeys([latestOpenKey]);
              localStorage.setItem('openMenuKeys', JSON.stringify([latestOpenKey]));
            } else {
              setOpenKeys([]);
              localStorage.setItem('openMenuKeys', JSON.stringify([]));
            }
          }}
          onClick={({ key, keyPath }) => {
            const newKeys = [key];
            setSelectedKeys(newKeys);
            
            // If clicking a submenu item, keep its parent menu open
            if (keyPath.length > 1) {
              const parentKey = keyPath[keyPath.length - 1];
              setOpenKeys([parentKey]);
              localStorage.setItem('openMenuKeys', JSON.stringify([parentKey]));
            } else {
              // If clicking a top-level menu item, close all submenus
              setOpenKeys([]);
              localStorage.setItem('openMenuKeys', JSON.stringify([]));
            }
            localStorage.setItem('selectedMenuKeys', JSON.stringify(newKeys));
            
            // If it's a submenu item, make sure parent menu stays open
            if (keyPath.length > 1) {
              const parentKey = keyPath[1];
              if (!openKeys.includes(parentKey)) {
                const newOpenKeys = [...openKeys, parentKey];
                setOpenKeys(newOpenKeys);
                localStorage.setItem('openMenuKeys', JSON.stringify(newOpenKeys));
              }
            }
            
            // Auto-collapse sidebar on mobile when menu item is clicked
            if (isMobile && key !== "signout") {
              setCollapsed(true);
            }
            
            if (key === "signout") {
            } else {
              navigate(key);
            }
          }}
          items={[
            {
              key: "",
              icon: <AiOutlineDashboard className="fs-4" />,
              label: "Dashboard",
            },
            {
              key: "customers",
              icon: <AiOutlineUser className="fs-4" />,
              label: "Users",
            },
            {
              key: "setting",
              icon: <IoIosSettings className="fs-4" />,
              label: "Setting",
            },
            {
              key: "Catalog",
              icon: <AiOutlineFlag className="fs-4" />,
              label: "Report",
              children: [
                {
                  key: "report-user",
                  icon: <AiOutlineUser className="fs-4" />,
                  label: "Reported Profile",
                },
              ]
            },
            {
              key: "Payments",
              icon: <AiOutlineDollar className="fs-4" />,
              label: "Subscription",
              children: [
                {
                  key: "subscription",
                  icon: <AiOutlineDollar className="fs-4" />,
                  label: "Packages",
                },
                {
                  key: "user-subscriptions",
                  icon: <AiFillAccountBook className="fs-4" />,
                  label: "Subscriptions",
                },
                {
                  key: "user-payments",
                  icon: <AiFillAccountBook className="fs-4" />,
                  label: "Island Pass Payments",
                },
                {
                  key: "subscription-logs",
                  icon: <AiFillAccountBook className="fs-4" />,
                  label: "Logs",
                },
              ]
            },
            {
              key: "collaboration",
              icon: <AiOutlineDollar className="fs-4" />,
              label: "Find A Collab",
            },
            {
              key: "diamond-user",
              icon: <AiOutlineUser className="fs-4" />,
              label: "Island Pass Users",
            },
            {
              key: "send-notification",
              icon: <AiOutlineNotification className="fs-4" />,
              label: "Notification",
            },
            {
              key: "notification-log",
              icon: <AiOutlineMenu className="fs-4" />,
              label: "Notification Logs",
            },
            {
              key: "chat",
              icon: <AiFillAccountBook className="fs-4" />,
              label: "Chat",
            },
          ]}
        />
      </Sider>

      <Layout className="site-layout" style={{ 
        marginLeft: isMobile ? 0 : (collapsed ? 0 : 0),
        transition: 'all 0.2s'
      }}>
        <Header
          className="d-flex justify-content-between align-items-center ps-1 pe-3"
          style={{
            padding: 0,
            background: colorBgContainer,
            position: 'sticky',
            top: 0,
            zIndex: 998,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
        >
          {/* Left side - Logo and brand */}
          <div className="d-flex align-items-center">
            {isMobile ? (
              <>
                <div className="d-flex align-items-center ms-2">
                  <img
                    src={`${process.env.PUBLIC_URL}/logo.png`}
                    style={{ width: 100 }}
                    alt="IBIZA"
                  />
                </div>
              </>
            ) : (
              /* Desktop menu toggle */
              React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: "trigger p-3",
                  onClick: () => setCollapsed(!collapsed),
                }
              )
            )}
          </div>
          
          {/* Right side - User profile */}
          <div className="d-flex align-items-center">
            <div className="d-flex gap-2 align-items-center dropdown">
              <div
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {user?.profile_pic_url ? (
                  <img
                    width={32}
                    height={32}
                    src={user.profile_pic_url}
                    alt=""
                    style={{ borderRadius: '50%', cursor: 'pointer' }}
                  />
                ) : (
                  <div 
                    style={{ 
                      width: 32, 
                      height: 32, 
                      borderRadius: '50%', 
                      backgroundColor: '#179296',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      cursor: 'pointer'
                    }}
                  >
                    {user?.first_name?.charAt(0) || 'U'}
                  </div>
                )}
              </div>

              {/* Menu toggle button next to logo on mobile */}
              {isMobile && (<div className="ms-3">
                {React.createElement(
                  collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                  {
                    className: "trigger p-2",
                    onClick: () => setCollapsed(!collapsed),
                    style: { fontSize: '20px' }
                  }
                )}
              </div>)}
              
              {/* User name and email (only on desktop) */}
              {!isMobile && (
                <div>
                  {user?.first_name && (
                    <h5 className="mb-0">{user.first_name}</h5>
                  )}
                  {user?.email && (
                    <p className="mb-0">{user.email}</p>
                  )}
                </div>
              )}
              
              {/* Dropdown menu */}
              <div className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="#"
                    onClick={handleSignout}
                  >
                    Signout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </Header>
        {/* <MatchNotifier userId={user.id} /> */}

        <Content
          style={{
            margin: isMobile ? "16px 8px" : "24px 16px",
            padding: isMobile ? 16 : 24,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <ToastContainer
            position="top-right"
            autoClose={250}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="light"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout >
  );
};
export default MainLayout;
